var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTablerWeight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 9C13.6569 9 15 7.65685 15 6C15 4.34315 13.6569 3 12 3C10.3431 3 9 4.34315 9 6C9 7.65685 10.3431 9 12 9Z",
    stroke: "#51607A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.83503 9H17.165C17.3992 8.99996 17.626 9.08213 17.8058 9.23216C17.9856 9.3822 18.1071 9.59059 18.149 9.821L19.786 18.821C19.8122 18.9651 19.8065 19.1133 19.7691 19.2549C19.7318 19.3966 19.6638 19.5283 19.5699 19.6408C19.476 19.7532 19.3586 19.8437 19.2259 19.9058C19.0932 19.9679 18.9485 20 18.802 20H5.19803C5.05153 20 4.90682 19.9679 4.77413 19.9058C4.64144 19.8437 4.524 19.7532 4.43014 19.6408C4.33627 19.5283 4.26826 19.3966 4.23091 19.2549C4.19357 19.1133 4.1878 18.9651 4.21403 18.821L5.85103 9.821C5.89295 9.59059 6.01441 9.3822 6.19423 9.23216C6.37405 9.08213 6.60083 8.99996 6.83503 9V9Z",
    stroke: "#51607A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTablerWeight);
export default __webpack_public_path__ + "static/media/tabler-weight.7a3935fc0cadc9fed3972b2cc6916169.svg";
export { ForwardRef as ReactComponent };